"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _styledComponents = _interopRequireDefault(require("styled-components"));
var _WishlistIcons = require("./WishlistIcons");
function _getRequireWildcardCache(e) { if ("function" != typeof WeakMap) return null; var r = new WeakMap(), t = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(e) { return e ? t : r; })(e); }
function _interopRequireWildcard(e, r) { if (!r && e && e.__esModule) return e; if (null === e || "object" != _typeof(e) && "function" != typeof e) return { "default": e }; var t = _getRequireWildcardCache(r); if (t && t.has(e)) return t.get(e); var n = { __proto__: null }, a = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var u in e) if ("default" !== u && {}.hasOwnProperty.call(e, u)) { var i = a ? Object.getOwnPropertyDescriptor(e, u) : null; i && (i.get || i.set) ? Object.defineProperty(n, u, i) : n[u] = e[u]; } return n["default"] = e, t && t.set(e, n), n; }
var WishlistActions = function WishlistActions(props) {
  var onShareWishlist = props.onShareWishlist,
    onDestroyWishlist = props.onDestroyWishlist,
    leadmailerLink = props.leadmailerLink;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    showTooltip = _useState2[0],
    setShowTooltip = _useState2[1];
  var handleShareWishlist = function handleShareWishlist() {
    onShareWishlist();
    setShowTooltip(true);
    setTimeout(function () {
      setShowTooltip(false);
    }, 5000);
  };
  return /*#__PURE__*/_react["default"].createElement(Actions, null, leadmailerLink ? /*#__PURE__*/_react["default"].createElement(LeadmailerButton, {
    as: "a",
    href: leadmailerLink,
    target: "_blank",
    rel: "noreferrer"
  }, /*#__PURE__*/_react["default"].createElement(_WishlistIcons.EmailIcon, {
    width: 30,
    height: 17,
    fill: "#5CB85C"
  })) : null, /*#__PURE__*/_react["default"].createElement(ActionButton, {
    onClick: handleShareWishlist,
    type: "button",
    title: "\u041F\u043E\u0434\u0435\u043B\u0438\u0442\u044C\u0441\u044F"
  }, /*#__PURE__*/_react["default"].createElement(_WishlistIcons.ShareIcon, {
    width: 30,
    height: 17,
    fill: "#0089c2"
  })), showTooltip && /*#__PURE__*/_react["default"].createElement(ShareTooltip, null, "\u0421\u0441\u044B\u043B\u043A\u0430 \u043D\u0430 \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u043E\u0435 \u0441\u043A\u043E\u043F\u0438\u0440\u043E\u0432\u0430\u043D\u0430", /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement("br", null), "\u041E\u0442\u043F\u0440\u0430\u0432\u044C\u0442\u0435 \u0435\u0435 \u0434\u0440\u0443\u0433\u0443 \u0438\u043B\u0438 \u0440\u043E\u0434\u0441\u0442\u0432\u0435\u043D\u043D\u0438\u043A\u0443 \u0447\u0442\u043E\u0431\u044B \u0441\u043E\u0432\u043C\u0435\u0441\u0442\u043D\u043E \u043D\u0430\u043F\u043E\u043B\u043D\u044F\u0442\u044C \u0441\u043F\u0438\u0441\u043E\u043A \u0438\u0437\u0431\u0440\u0430\u043D\u043D\u044B\u0445 \u043F\u043E\u0438\u0441\u043A\u043E\u0432, \u043E\u0442\u0435\u043B\u0435\u0439 \u0438 \u0442\u0443\u0440\u043E\u0432."), /*#__PURE__*/_react["default"].createElement(DestroyButton, {
    onClick: onDestroyWishlist,
    type: "button"
  }, "\u041E\u0447\u0438\u0441\u0442\u0438\u0442\u044C"));
};
var Actions = _styledComponents["default"].div.withConfig({
  displayName: "WishlistActions__Actions",
  componentId: "sc-u2kxra-0"
})(["background-color:#fff;border-top:1px solid #ddd;padding:7px;display:flex;position:relative;"]);
var ActionButton = _styledComponents["default"].button.withConfig({
  displayName: "WishlistActions__ActionButton",
  componentId: "sc-u2kxra-1"
})(["cursor:pointer;background:none;border:none;outline:none;height:20px;"]);
var LeadmailerButton = (0, _styledComponents["default"])(ActionButton).withConfig({
  displayName: "WishlistActions__LeadmailerButton",
  componentId: "sc-u2kxra-2"
})(["margin-right:7px;"]);
var DestroyButton = (0, _styledComponents["default"])(ActionButton).withConfig({
  displayName: "WishlistActions__DestroyButton",
  componentId: "sc-u2kxra-3"
})(["font-size:12px;color:#a50000;margin-left:auto;"]);
var ShareTooltip = _styledComponents["default"].div.withConfig({
  displayName: "WishlistActions__ShareTooltip",
  componentId: "sc-u2kxra-4"
})(["position:absolute;bottom:35px;left:0;padding:10px 12px;width:100%;height:105px;color:#fff;background:#3bacf5;font-size:14px;"]);
var _default = exports["default"] = WishlistActions;